import {DirectiveBinding} from "vue/types/options";
import {VNode} from "vue";
import {fail} from "./util";


class HandleContainer {
    private dragContainer: Element;

    constructor(vNode: VNode,
                directiveBinding: DirectiveBinding) {
        const dragContainer = findParentDraggableNode(vNode.elm)

        if (!dragContainer) {
            fail("v-dnd:handle should only be set inside a " +
                "v-dnd:drag or draggable element for", vNode, "with",
                directiveBinding)
        }

        if (directiveBinding.modifiers.css) {
            (<Element>vNode.elm).classList.add("dnd-drag-handle")
        }

        this.dragContainer = <Element>dragContainer
        this.dragContainer.setAttribute("draggable", "false")
    }

    mouseEnter = (ev: MouseEvent) => {
        this.dragContainer.setAttribute("draggable", "true")
    }

    mouseLeave = (ev: MouseEvent) => {
        this.dragContainer.setAttribute("draggable", "false")
    }
}

export function registerHandle(element: HTMLElement,
                               binding: DirectiveBinding,
                               vnode: VNode,
                               oldVnode: VNode) {
    const handleContainer = new HandleContainer(vnode, binding)

    element.addEventListener("mouseenter", handleContainer.mouseEnter)
    element.addEventListener("mouseleave", handleContainer.mouseLeave)
}

function findParentDraggableNode(elm: Node | undefined) : HTMLElement | null {
    if (!elm) {
        return null
    }

    let searchElement: HTMLElement | null = <HTMLElement>elm

    while (searchElement && !searchElement.attributes.getNamedItem("draggable")) {
        searchElement = searchElement.parentElement
    }

    return searchElement
}
